module.exports = __webpack_public_path__ + "static/img/Image_013.dd64340.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/Image_013.jpg
// module id = qziz
// module chunks = 3